import { render, staticRenderFns } from "./SideBarUpdates.vue?vue&type=template&id=60672959&scoped=true&"
import script from "./SideBarUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60672959",
  null
  
)

export default component.exports